import {Routes} from '@angular/router'
import {
  ROUTE_NOT_FOUND,
  ROUTE_PARAM_PROJECT_ID,
  ROUTE_PROJECT,
  ROUTE_PROJECT_CUSTOMER_SPEC,
  ROUTE_PROJECT_FACTORY_SPEC,
  ROUTE_PROJECT_OFFER
} from '../../application/constants'

export default [
  {
    path: ROUTE_PROJECT,
    children: [
      {
        path: ROUTE_NOT_FOUND,
        pathMatch: 'full',
        loadComponent: () =>
          import('./not-found/project-not-found.component').then(c => c.ProjectNotFoundComponent)
      },
      {
        path: `:${ROUTE_PARAM_PROJECT_ID}`,
        loadComponent: () =>
          import('./project-holder.component').then(c => c.ProjectHolderComponent),
        children: [
          {
            path: ROUTE_PROJECT_OFFER,
            pathMatch: 'full',
            loadComponent: () =>
              import('./home/project-home.component').then(c => c.ProjectHomeComponent)
          },
          {
            path: ROUTE_PROJECT_CUSTOMER_SPEC,
            loadComponent: () => import('./customer-spec/project-customer-spec.component')
              .then(c => c.ProjectCustomerSpecComponent)
          },
          {
            path: ROUTE_PROJECT_FACTORY_SPEC,
            loadComponent: () => import('./factory-spec/project-factory-spec.component')
              .then(c => c.ProjectFactorySpecComponent)
          },
          {
            path: `**`,
            redirectTo: ROUTE_PROJECT_OFFER
          }
        ]
      },
      {
        path: '**',
        redirectTo: ROUTE_NOT_FOUND
      }
    ]
  },
] as Routes
